import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { Button } from '../../Inputs';
import styles from './NavigationGuardMessage.scss';

export function NavigationGuardMessage({ cancel, leave }) {
    const { t } = useTranslation('ui');

    return (
        <div className={styles.root}>
            <div className={styles.content}>
                <p>{t('NavigationGuardMessage.message')}</p>
            </div>
            <div>
                <Button type="button" fullWidth btnStyle="secondary2" onClick={cancel} style={{ marginBottom: 12 }}>
                    {t('NavigationGuardMessage.buttons.goBack')}
                </Button>
                <Button type="button" fullWidth btnStyle="danger" onClick={leave}>
                    {t('NavigationGuardMessage.buttons.exitNoSave')}
                </Button>
            </div>
        </div>
    );
}

NavigationGuardMessage.propTypes = {
    cancel: PropTypes.func.isRequired,
    leave: PropTypes.func.isRequired,
};
